import angular from "angular";

angular.module('ui-sentinel.devices.latestDeviceTracking', [
    'ui-sentinel.devices',
    'ui-sentinel.maps',
    'ui-sentinel.devices.deviceReportToolItem'
]);
